// extracted by mini-css-extract-plugin
module.exports = {"fondo":"TabsVideos__fondo__19jqu","containerDiv":"TabsVideos__containerDiv__uQTs4","container":"TabsVideos__container__1dfgf","thumbanil":"TabsVideos__thumbanil__10fpj"};